<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
        <span>User record with id: not found. </span>
        <span>
            <span>Check </span>
            <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
        </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">

        <vx-card class="mb-base">

            <!-- Avatar -->
            <div class="vx-row">

                <!-- Avatar Col -->
                <div class="vx-col" id="avatar-col">
                    <div class="img-container mb-4">
                        <img :src=this.$store.state.AppActiveUser.image class="rounded w-full" />
                    </div>
                </div>

                <!-- Information - Col 1 -->
                <div class="vx-col flex-1" id="account-info-col-1">
                    <table>
                        <tr>
                            <td class="font-semibold">Nom</td>
                            <td>{{ user_data.nom }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Prénom</td>
                            <td>{{ user_data.prenom }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Email</td>
                            <td>{{ user_data.email }}</td>
                        </tr>
                    </table>
                </div>
                <!-- /Information - Col 1 -->

                <!-- Information - Col 2 -->
                <div class="vx-col flex-1" id="account-info-col-2">
                    <table>
                        <tr>
                            <td class="font-semibold">Status</td>
                            <td>{{ user_data.status }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Role</td>
                            <td>{{ user_data.role }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Société
                            </td>
                            <td>{{ user_data.societe.nom }}</td>
                        </tr>
                    </table>
                </div>
                <!-- /Information - Col 2 -->
                <div class="vx-col w-full flex" id="account-manage-buttons" v-if="canUpdate()">
                    <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'profile-modifier' }">Modifier</vs-button>

                </div>

            </div>

        </vx-card>

        <div class="vx-row">
            <div class="vx-col lg:w-1/2 w-full">
                <vx-card title="Information" class="mb-base">
                    <table>
                        <tr>
                            <td class="font-semibold">Date de naissance</td>
                            <td style="padding-left:80px">{{ user_data.dob }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Téléphone</td>
                            <td style="padding-left:80px"> +216 {{ user_data.mobile }}</td>
                        </tr>

                        <tr>
                            <td class="font-semibold">Genre</td>
                            <td style="padding-left:80px">{{ user_data.genre }}</td>
                        </tr>

                    </table>
                </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
                <vx-card title="Réseaux sociaux" class="mb-base">
                    <table>
                        <tr>
                            <td class="font-semibold">Facebook</td>
                            <td style="padding-left:80px">{{ user_data.social_links.facebook }}</td>
                        </tr>

                        <tr>
                            <td class="font-semibold">Instagram</td>
                            <td style="padding-left:80px">{{ user_data.social_links.instagram }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">Twitter</td>
                            <td style="padding-left:80px">{{ user_data.social_links.twitter }}</td>
                        </tr>
                    </table>
                </vx-card>
            </div>
        </div>

        <!-- Permissions -->

    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            user_data: null,
            user_not_found: false,
        }
    },
     mounted()
    {
         this.user_data = this.$store.state.AppActiveUser;
       this.image=this.$store.state.AppActiveUser.image
    },
    computed: {
        userAddress() {
            let str = ""
            for (var field in this.user_data.location) {
                str += field + " "
            }
            return str
        }
    },
    methods: {
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm Delete`,
                text: `You are about to delete "${this.user_data.username}"`,
                accept: this.deleteRecord,
                acceptText: "Delete"
            })
        },
        deleteRecord() {
            /* Below two lines are just for demo purpose */
            this.$router.push({
                name: 'app-user-list'
            });
            this.showDeleteSuccess()

            /* UnComment below lines for enabling true flow if deleting user */
            // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
            //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
            //   .catch(err => { console.error(err)       })
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                title: 'User Deleted',
                text: 'The selected user was successfully deleted'
            })
        },
        canUpdate(){
            return this.user_data.role != 'Fournisseur'
        }
        
    },
    created() {
        this.user_data = this.$store.state.AppActiveUser;
    }
}
</script>

<style lang="scss">
#avatar-col {
    width: 10rem;
}

#page-user-view {
    table {
        td {
            vertical-align: top;
            min-width: 140px;
            padding-bottom: .8rem;
            word-break: break-all;
        }

        &:not(.permissions-table) {
            td {
                @media screen and (max-width:370px) {
                    display: block;
                }
            }
        }
    }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
    #account-info-col-1 {
        width: calc(100% - 12rem) !important;
    }

}
</style>
